import { Component, Output, Input, EventEmitter } from '@angular/core';

import { PermissionService, checkPermission } from 'src/app/shared/services/permission.service';
import { SessionService } from 'src/app/shared/services/session.service';

type FuncAction = (event: Event) => void;

export interface RegisterAction {
  button?: boolean;
  btnStyle?: string | string[];
  permission?: string[];
  icon?: string;
  caption?: string;
  title?: string;
  handler: FuncAction;
}

export interface RegisterHeaderConfig {
  actions?: RegisterAction[];
  permissions?: {
    namespace: string;
    save?: string | string[];
    delete?: string | string[];
  };
  hidenBtn?: {
    save?: boolean;
    delete?: boolean;
  };
}

export interface RegisterHeaderEvent extends Event {
  promise?(callback: Function);
}

@Component({
  selector: 'app-register-header',
  templateUrl: './register-header.component.html',
  styleUrls: ['./register-header.component.scss']
})
export class RegisterHeaderComponent {
  @Input() public title: string;
  @Input() public canReturnBtn = true;
  @Input() public showSaveBtn = true;
  @Input() public SaveCaption = 'Salvar';
  @Input() public SaveTitle = 'Salva e permanece alterando';
  @Input() public showSaveReturnBtn = true;
  @Input() public saveReturnCaption = 'Concluir';
  @Input() public saveReturnTitle = 'Salva e retorna aos registros';

  // tslint:disable-next-line: no-output-on-prefix
  @Output() public onReturn = new EventEmitter();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() public onSave = new EventEmitter();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() public onSaveAndReturn = new EventEmitter();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() public onDelete = new EventEmitter();

  public canSave = false;
  public canDelete = false;
  public actionHeader: RegisterAction[] = [];
  public actionOption: RegisterAction[] = [];
  public disabled = false;
  public refresh = -1;
  public refreshHeader = -1;
  public refreshOption = -1;

  constructor(
    private permissionService: PermissionService,
    private sessionService: SessionService
  ) { }

  @Input('config')
  public set config(config: RegisterHeaderConfig) {
    if (config) {
      if (config.permissions) {
        const perm = config.permissions;
        const hidenBtn = config.hidenBtn || {};

        if (perm.save && !hidenBtn.save) {
          this.permissionService
            .hasPermission(perm.namespace, perm.save)
            .subscribe(ok => this.canSave = ok);
        }

        if (perm.delete && !hidenBtn.delete) {
          this.permissionService
            .hasPermission(perm.namespace, perm.delete)
            .subscribe(ok => this.canDelete = ok);
        }
      } else {
        this.canSave = !config.hidenBtn ? true : !config.hidenBtn.save;
      }

      this.actions(config.actions || []);
    }
  }

  private actions(actions: RegisterAction[]) {
    this.actionHeader = [];
    this.actionOption = [];

    this.sessionService.userData().subscribe(userData => {
      actions = actions.filter(action => {
        if (action.permission) {
          const [namespace, actionName] = action.permission;
          return userData.permissions.some(perm => checkPermission(perm, namespace, actionName));
        }

        return true;
      });

      this.actionHeader = actions.filter(action => action.button);
      this.actionOption = actions.filter(action => !action.button);
    });
  }

  public canMore(): boolean {
    return this.canSave || this.canDelete;
  }

  public onReturnEmit(event: RegisterHeaderEvent): void {
    if (this.disabled) { return; }
    event.promise = this.createPromise(null, 0).bind(this);
    this.onReturn.emit(event);
  }

  public onSaveEmit(event: RegisterHeaderEvent): void {
    if (this.disabled) { return; }
    event.promise = this.createPromise('B', 1).bind(this);
    this.onSave.emit(event);
  }

  public onSaveAndReturnEmit(event: RegisterHeaderEvent): void {
    if (this.disabled) { return; }
    event.promise = this.createPromise('B', 2).bind(this);
    this.onSaveAndReturn.emit(event);
  }

  public onDeleteEmit(event: RegisterHeaderEvent): void {
    if (this.disabled) { return; }
    event.promise = this.createPromise(null, 0).bind(this);
    this.onDelete.emit(event);
  }

  public executeHandler(event: RegisterHeaderEvent, index: number, action: RegisterAction): void {
    if (this.disabled) { return; }
    if (action && event) {
      event.promise = this.createPromise(action.button ? 'H' : 'O', index).bind(this);
      action.handler(event);
    }
  }

  private createPromise(type: string, refresh: number) {
    return (call: any): void => {

      this.disabled = true;

      switch (type) {
        case 'B': this.refresh = refresh; break;
        case 'H': this.refreshHeader = refresh; break;
        case 'O': this.refreshOption = refresh; break;
      }

      new Promise(call)
        .then(() => this.donePromise())
        .catch(() => this.donePromise());
    };
  }

  private donePromise(): void {
    this.disabled = false;
    this.refresh = -1;
    this.refreshHeader = -1;
    this.refreshOption = -1;
  }
}
